import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { trackEvent } from '@/shared/lib/analytics';

interface EmailCTAProps {
  location: 'hero' | 'footer';
}

export function EmailCTA({ location }: EmailCTAProps) {
  const { t } = useTranslation();

  return (
    <Link
      to="/app/templates"
      onClick={() => trackEvent('cta_clicked', { location })}
      className="inline-block bg-gradient-to-br from-emerald-500 to-teal-600 hover:from-emerald-400 hover:to-teal-500 text-white font-medium px-10 py-4 rounded-lg text-base transition-all"
    >
      {t('hero.getStarted')}
    </Link>
  );
}
